import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import '../styles/layout.css';

const Layout = () => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <div className="app-container">
      <Navbar />
      <main className={`main-content ${isDashboard ? 'main-content--dashboard' : ''}`}>
        <Outlet />
      </main>
      {!isDashboard && (
        <footer className="footer">
          <div className="footer__inner">
            <div className="footer__brand">
              <span className="footer__logo">ORN</span>
              <span className="footer__tagline">Media Intelligence, Refined.</span>
            </div>
            <p className="footer__copy">&copy; {new Date().getFullYear()} Online Record News. All rights reserved.</p>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;
